import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import { BudgetPages } from '../../pages/BudgetPages';
import StorageService from 'src/services/storage.service';

export interface ScrollRestorationProps {
    scrollElementId: string;
    debounceMs?: number;
}

const pagesWithScrollRestoration = [BudgetPages.HOME];

const SCROLL_EVENT: string = 'scroll';
const DEFAULT_DEBOUNCE = 50;

function ScrollRestoration({ scrollElementId, debounceMs = DEFAULT_DEBOUNCE }: ScrollRestorationProps): JSX.Element {
    const { action } = useHistory();
    const { pathname } = useLocation();
    const scrollRestorationEnabledForPage = pagesWithScrollRestoration.includes(pathname);

    const getScrollElement = (id: string = scrollElementId): HTMLElement | null => document.getElementById(id);

    const scrollTo = (scrollnumber: number = 0): void => getScrollElement()?.scrollTo(0, scrollnumber);

    const handleScroll = debounce(
        (): void => StorageService.setScrollRestorationForPage(pathname, getScrollElement()?.scrollTop || 0),
        debounceMs
    );

    useEffect(() => {
        if (!scrollRestorationEnabledForPage) return;

        if (action === 'POP') {
            scrollTo(StorageService.getScrollRestorationForPage(pathname));
        }

        const se = getScrollElement();
        se?.addEventListener(SCROLL_EVENT, handleScroll);
        return () => {
            se?.removeEventListener(SCROLL_EVENT, handleScroll);
        };
    }, []);

    return null; // React component renders no UI
}

export default ScrollRestoration;
